import { bool, mixed, object, string } from 'yup';

import { NO_NULL_UUID_MATCH } from '@uplift/constants';
import { l10nEnService } from '@uplift/services';
import { AddressType } from '@uplift/types';
import { createDobFieldValidation, settingsAddressValidation } from '@uplift/ui-v2';
import {
  applyNameValidator,
  VALIDATION_INSURANCE_GROUP_NUMBER,
  VALIDATION_INSURANCE_PROVIDER_NAME,
  VALIDATION_INSURANCE_SUBSCRIBER_ID
} from '@uplift/validations';


export type InsuranceInfoFormValues = {
  isPrimarySubscriber: boolean;
  insuranceProvider: string;
  insuranceProviderFreeText?: string;
  memberId: string;
  groupNumber: string;
  insuranceCardFront: string | null;
  insuranceCardBack: string | null;
  primarySubscriberFirstName?: string;
  primarySubscriberLastName?: string;
  primarySubscriberDateOfBirth?: string | null;
  address?: AddressType;
};

export const insuranceInfoValidation = (l10n: typeof l10nEnService, validateInsuranceFreeText: boolean) =>
  object({
    isPrimarySubscriber: bool().required(),
    insuranceProvider: validateInsuranceFreeText ? undefined : string().matches(NO_NULL_UUID_MATCH, l10n.validations.insurance).required(l10n.validations.insurance),
    insuranceProviderFreeText: validateInsuranceFreeText ? VALIDATION_INSURANCE_PROVIDER_NAME : undefined,
    memberId: VALIDATION_INSURANCE_SUBSCRIBER_ID,
    groupNumber: VALIDATION_INSURANCE_GROUP_NUMBER,
    insuranceCardFront: mixed().required(l10n.validations.insuranceCardFront),
    insuranceCardBack: mixed().required(l10n.validations.insuranceCardBack),
    primarySubscriberFirstName: string()
      .when('isPrimarySubscriber', {
        is: false,
        then: s => applyNameValidator(s)
          .required(l10n.validations.primarySubFirstName)
      }),
    primarySubscriberLastName: string().notRequired()
      .when('isPrimarySubscriber', {
        is: false,
        then: s => applyNameValidator(s)
          .required(l10n.validations.primarySubLastName)
      }),
    primarySubscriberDateOfBirth: mixed().nullable().notRequired()
      .when('isPrimarySubscriber', {
        is: false,
        then: _s => createDobFieldValidation(l10n, { adult: true }),
      }),
    address: mixed()
      .when('isPrimarySubscriber', {
        is: false,
        then: _s => settingsAddressValidation(l10n)
      }),
  });
